export const HAS_NUMBER_REGEX = /^([^0-9]*)$/
export const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/
export const MOBILE_REGEX = /^(6|7)[0-9]{8}$/
export const IS_SPANISH_REGEX = /^ES$/
export const NIF_NIE_REGEX = /^(\d{8})(\D)$|^[XYZ]\d{7,8}\D$/
export const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/
export const NIF_REGEX = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i
export const ICC_REGEX = /^(8|9)[0-9]{18}$/
export const EMAIL_REGEX = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/
export const POST_CODE_REGEX = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/
export const MOBILE_OR_LANDLINE = /^(8|9|6|7)[0-9]{8}$/
